import { fetchAccountInterests, postAccountInterests } from "flux/clients/accountInterest";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const queryKey = 'account-interest';
export function useAccountInterestWithPrefix(prefix: string) {
  const queryClient = useQueryClient();
  const state = useQuery([queryKey, prefix || 'all'], () => fetchAccountInterests(prefix))
  const update = useMutation((data: Record<string, string>) => postAccountInterests(data, prefix),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey], { refetchType: 'active' });
      },
      retry: 2,
    })
  return {...state, update }
}
